/** 原则 ： 22年有数据用22年的，22年没数据则用21年的，为了让列表可以下钻。
 * 1 下面国家用的是21年数据， 其他国家用的是22年数据
 *   Russia、Thailand、Portugal、Ireland、Hungary、Switzerland、Czech Republic、Norway、Denmark、Israel、
 * 2 South Africa的Player用的是22年数据，revenue用的是21年数据
 */
export const pcConsoleFixData = {
  'United States': {
    marketNameEn: 'us',
    pcPlayer: '92.3M',
    consolePlayer: '114.2M',
    pcRevenue: '7.9B',
    consoleRevenue: '21.1B',
    marketName: 'United States',
    marketPhysicalRevenuePrecent: 0,
    marketFlag: 'https://ogdb-cdn.intlgame.cn/front/static/img/flag0321/us.svg',
    rank: 37,
    marketDigitalRevenuePrecent: 0,
    marketPhysicalRevenue: 0,
    marketDigitalRevenue: 0,
  },
  Thailand: {
    marketNameEn: 'th',
    consolePlayer: '13.1M',
    pcRevenue: '240M',
    marketName: 'Thailand',
    pcPlayer: '17.8M',
    marketPhysicalRevenuePrecent: 0,
    marketFlag: 'https://ogdb-cdn.intlgame.cn/front/static/img/flag0321/th.svg',
    rank: 33,
    marketDigitalRevenuePrecent: 0,
    marketPhysicalRevenue: 0,
    consoleRevenue: '88.3M',
    marketDigitalRevenue: 0,
  },
  Portugal: {
    marketNameEn: 'pt',
    consolePlayer: '3.63M',
    pcRevenue: '96M',
    marketName: 'Portugal',
    pcPlayer: '3.87M',
    marketPhysicalRevenuePrecent: 0,
    marketFlag: 'https://ogdb-cdn.intlgame.cn/front/static/img/flag0321/pt.svg',
    rank: 25,
    marketDigitalRevenuePrecent: 0,
    marketPhysicalRevenue: 0,
    consoleRevenue: '305M',
    marketDigitalRevenue: 0,
  },
  Russia: {
    marketNameEn: 'ru',
    pcPlayer: '55.5M',
    consolePlayer: '28.7M',
    pcRevenue: '655M',
    consoleRevenue: '445M',
    marketName: 'Russia',
    marketPhysicalRevenuePrecent: 0,
    marketFlag: 'https://ogdb-cdn.intlgame.cn/front/static/img/flag0321/ru.svg',
    rank: 26,
    marketDigitalRevenuePrecent: 0,
    marketPhysicalRevenue: 0,
    marketDigitalRevenue: 0,
  },
  'Saudi Arabia': {
    marketNameEn: 'sa',
    pcPlayer: '10.0M',
    consolePlayer: '7.0M',
    pcRevenue: '0.2B',
    consoleRevenue: '0.2B',
    marketName: 'Saudi Arabia',
    marketPhysicalRevenuePrecent: 0,
    marketFlag: 'https://ogdb-cdn.intlgame.cn/front/static/img/flag0321/sa.svg',
    rank: 27,
    marketDigitalRevenuePrecent: 0,
    marketPhysicalRevenue: 0,
    marketDigitalRevenue: 0,
  },
  Austria: {
    marketNameEn: 'at',
    pcPlayer: '6.4M',
    consolePlayer: '7.4M',
    pcRevenue: '0.4B',
    consoleRevenue: '0.8B',
    marketName: 'Austria',
    marketPhysicalRevenuePrecent: 0,
    marketFlag: 'https://ogdb-cdn.intlgame.cn/front/static/img/flag0321/at.svg',
    rank: 3,
    marketDigitalRevenuePrecent: 0,
    marketPhysicalRevenue: 0,
    marketDigitalRevenue: 0,
  },
  Netherlands: {
    marketNameEn: 'nl',
    pcPlayer: '4.3M',
    consolePlayer: '4.8M',
    pcRevenue: '0.2B',
    consoleRevenue: '0.6B',
    marketName: 'Netherlands',
    marketPhysicalRevenuePrecent: 0,
    marketFlag: 'https://ogdb-cdn.intlgame.cn/front/static/img/flag0321/nl.svg',
    rank: 21,
    marketDigitalRevenuePrecent: 0,
    marketPhysicalRevenue: 0,
    marketDigitalRevenue: 0,
  },
  'South Korea': {
    marketNameEn: 'kr',
    pcPlayer: '21.2M',
    consolePlayer: '9.6M',
    pcRevenue: '2.5B',
    consoleRevenue: '0.7B',
    marketName: 'South Korea',
    marketPhysicalRevenuePrecent: 0,
    marketFlag: 'https://ogdb-cdn.intlgame.cn/front/static/img/flag0321/kr.svg',
    rank: 29,
    marketDigitalRevenuePrecent: 0,
    marketPhysicalRevenue: 0,
    marketDigitalRevenue: 0,
  },
  Sweden: {
    marketNameEn: 'se',
    pcPlayer: '3.5M',
    consolePlayer: '3.2M',
    pcRevenue: '0.1B',
    consoleRevenue: '0.4B',
    marketName: 'Sweden',
    marketPhysicalRevenuePrecent: 0,
    marketFlag: 'https://ogdb-cdn.intlgame.cn/front/static/img/flag0321/se.svg',
    rank: 31,
    marketDigitalRevenuePrecent: 0,
    marketPhysicalRevenue: 0,
    marketDigitalRevenue: 0,
  },
  Ireland: {
    marketNameEn: 'ie',
    consolePlayer: '1.89M',
    pcRevenue: '64.4M',
    marketName: 'Ireland',
    pcPlayer: '2.02M',
    marketPhysicalRevenuePrecent: 0,
    marketFlag: 'https://ogdb-cdn.intlgame.cn/front/static/img/flag0321/ie.svg',
    rank: 16,
    marketDigitalRevenuePrecent: 0,
    marketPhysicalRevenue: 0,
    consoleRevenue: '204M',
    marketDigitalRevenue: 0,
  },
  Brazil: {
    marketNameEn: 'br',
    pcPlayer: '41.8M',
    consolePlayer: '28.2M',
    pcRevenue: '0.7B',
    consoleRevenue: '0.7B',
    marketName: 'Brazil',
    marketPhysicalRevenuePrecent: 0,
    marketFlag: 'https://ogdb-cdn.intlgame.cn/front/static/img/flag0321/br.svg',
    rank: 5,
    marketDigitalRevenuePrecent: 0,
    marketPhysicalRevenue: 0,
    marketDigitalRevenue: 0,
  },
  Poland: {
    marketNameEn: 'pl',
    pcPlayer: '12.3M',
    consolePlayer: '8.3M',
    pcRevenue: '0.3B',
    consoleRevenue: '0.2B',
    marketName: 'Poland',
    marketPhysicalRevenuePrecent: 0,
    marketFlag: 'https://ogdb-cdn.intlgame.cn/front/static/img/flag0321/pl.svg',
    rank: 24,
    marketDigitalRevenuePrecent: 0,
    marketPhysicalRevenue: 0,
    marketDigitalRevenue: 0,
  },
  Chile: {
    marketNameEn: 'cl',
    pcPlayer: '4.0M',
    consolePlayer: '2.7M',
    pcRevenue: '0.1B',
    consoleRevenue: '0.1B',
    marketName: 'Chile',
    marketPhysicalRevenuePrecent: 0,
    marketFlag: 'https://ogdb-cdn.intlgame.cn/front/static/img/flag0321/cl.svg',
    rank: 7,
    marketDigitalRevenuePrecent: 0,
    marketPhysicalRevenue: 0,
    marketDigitalRevenue: 0,
  },
  France: {
    marketNameEn: 'fr',
    pcPlayer: '20.2M',
    consolePlayer: '22.5M',
    pcRevenue: '0.8B',
    consoleRevenue: '2.5B',
    marketName: 'France',
    marketPhysicalRevenuePrecent: 0,
    marketFlag: 'https://ogdb-cdn.intlgame.cn/front/static/img/flag0321/fr.svg',
    rank: 12,
    marketDigitalRevenuePrecent: 0,
    marketPhysicalRevenue: 0,
    marketDigitalRevenue: 0,
  },
  Colombia: {
    marketNameEn: 'co',
    pcPlayer: '8.9M',
    consolePlayer: '6.0M',
    pcRevenue: '0.1B',
    consoleRevenue: '0.1B',
    marketName: 'Colombia',
    marketPhysicalRevenuePrecent: 0,
    marketFlag: 'https://ogdb-cdn.intlgame.cn/front/static/img/flag0321/co.svg',
    rank: 8,
    marketDigitalRevenuePrecent: 0,
    marketPhysicalRevenue: 0,
    marketDigitalRevenue: 0,
  },
  Argentina: {
    marketNameEn: 'ar',
    pcPlayer: '11.3M',
    consolePlayer: '6.7M',
    pcRevenue: '0.2B',
    consoleRevenue: '0.2B',
    marketName: 'Argentina',
    marketPhysicalRevenuePrecent: 0,
    marketFlag: 'https://ogdb-cdn.intlgame.cn/front/static/img/flag0321/ar.svg',
    rank: 1,
    marketDigitalRevenuePrecent: 0,
    marketPhysicalRevenue: 0,
    marketDigitalRevenue: 0,
  },
  Hungary: {
    marketNameEn: 'hu',
    consolePlayer: '2.12M',
    pcRevenue: '61.5M',
    marketName: 'Hungary',
    pcPlayer: '3.50M',
    marketPhysicalRevenuePrecent: 0,
    marketFlag: 'https://ogdb-cdn.intlgame.cn/front/static/img/flag0321/hu.svg',
    rank: 14,
    marketDigitalRevenuePrecent: 0,
    marketPhysicalRevenue: 0,
    consoleRevenue: '42.4M',
    marketDigitalRevenue: 0,
  },
  Japan: {
    marketNameEn: 'jp',
    pcPlayer: '33.2M',
    consolePlayer: '42.2M',
    pcRevenue: '1.4B',
    consoleRevenue: '5.7B',
    marketName: 'Japan',
    marketPhysicalRevenuePrecent: 0,
    marketFlag: 'https://ogdb-cdn.intlgame.cn/front/static/img/flag0321/jp.svg',
    rank: 19,
    marketDigitalRevenuePrecent: 0,
    marketPhysicalRevenue: 0,
    marketDigitalRevenue: 0,
  },
  'United Kingdom': {
    marketNameEn: 'gb',
    pcPlayer: '17.7M',
    consolePlayer: '22.4M',
    pcRevenue: '1.1B',
    consoleRevenue: '2.9B',
    marketName: 'United Kingdom',
    marketPhysicalRevenuePrecent: 0,
    marketFlag: 'https://ogdb-cdn.intlgame.cn/front/static/img/flag0321/gb.svg',
    rank: 36,
    marketDigitalRevenuePrecent: 0,
    marketPhysicalRevenue: 0,
    marketDigitalRevenue: 0,
  },
  'United Arab Emirates': {
    marketNameEn: 'ae',
    pcPlayer: '3.1M',
    consolePlayer: '1.6M',
    pcRevenue: '0.1B',
    consoleRevenue: '0.1B',
    marketName: 'United Arab Emirates',
    marketPhysicalRevenuePrecent: 0,
    marketFlag: 'https://ogdb-cdn.intlgame.cn/front/static/img/flag0321/ae.svg',
    rank: 35,
    marketDigitalRevenuePrecent: 0,
    marketPhysicalRevenue: 0,
    marketDigitalRevenue: 0,
  },
  Switzerland: {
    marketNameEn: 'ch',
    consolePlayer: '3.29M',
    pcRevenue: '179M',
    marketName: 'Switzerland',
    pcPlayer: '3.51M',
    marketPhysicalRevenuePrecent: 0,
    marketFlag: 'https://ogdb-cdn.intlgame.cn/front/static/img/flag0321/ch.svg',
    rank: 32,
    marketDigitalRevenuePrecent: 0,
    marketPhysicalRevenue: 0,
    consoleRevenue: '569M',
    marketDigitalRevenue: 0,
  },
  Spain: {
    marketNameEn: 'es',
    pcPlayer: '18.7M',
    consolePlayer: '18.9M',
    pcRevenue: '0.4B',
    consoleRevenue: '1.5B',
    marketName: 'Spain',
    marketPhysicalRevenuePrecent: 0,
    marketFlag: 'https://ogdb-cdn.intlgame.cn/front/static/img/flag0321/es.svg',
    rank: 30,
    marketDigitalRevenuePrecent: 0,
    marketPhysicalRevenue: 0,
    marketDigitalRevenue: 0,
  },
  'New Zealand': {
    marketNameEn: 'nz',
    pcPlayer: '1.4M',
    consolePlayer: '1.4M',
    pcRevenue: '0.1B',
    consoleRevenue: '0.1B',
    marketName: 'New Zealand',
    marketPhysicalRevenuePrecent: 0,
    marketFlag: 'https://ogdb-cdn.intlgame.cn/front/static/img/flag0321/be.svg',
    rank: 22,
    marketDigitalRevenuePrecent: 0,
    marketPhysicalRevenue: 0,
    marketDigitalRevenue: 0,
  },
  Canada: {
    marketNameEn: 'ca',
    pcPlayer: '9.4M',
    consolePlayer: '11.5M',
    pcRevenue: '0.6B',
    consoleRevenue: '1.6B',
    marketName: 'Canada',
    marketPhysicalRevenuePrecent: 0,
    marketFlag: 'https://ogdb-cdn.intlgame.cn/front/static/img/flag0321/ca.svg',
    rank: 6,
    marketDigitalRevenuePrecent: 0,
    marketPhysicalRevenue: 0,
    marketDigitalRevenue: 0,
  },
  'Czech Republic': {
    marketNameEn: 'cz',
    consolePlayer: '2.44M',
    pcRevenue: '77.9M',
    marketName: 'Czech Republic',
    pcPlayer: '4.04M',
    marketPhysicalRevenuePrecent: 0,
    marketFlag: 'https://ogdb-cdn.intlgame.cn/front/static/img/flag0321/cz.svg',
    rank: 9,
    marketDigitalRevenuePrecent: 0,
    marketPhysicalRevenue: 0,
    consoleRevenue: '53.7M',
    marketDigitalRevenue: 0,
  },
  Turkey: {
    marketNameEn: 'tr',
    pcPlayer: '22.6M',
    consolePlayer: '14.3M',
    pcRevenue: '0.3B',
    consoleRevenue: '0.3B',
    marketName: 'Turkey',
    marketPhysicalRevenuePrecent: 0,
    marketFlag: 'https://ogdb-cdn.intlgame.cn/front/static/img/flag0321/tr.svg',
    rank: 34,
    marketDigitalRevenuePrecent: 0,
    marketPhysicalRevenue: 0,
    marketDigitalRevenue: 0,
  },
  Belgium: {
    marketNameEn: 'be',
    pcPlayer: '2.5M',
    consolePlayer: '2.7M',
    pcRevenue: '0.1B',
    consoleRevenue: '0.4B',
    marketName: 'Belgium',
    marketPhysicalRevenuePrecent: 0,
    marketFlag: 'https://ogdb-cdn.intlgame.cn/front/static/img/flag0321/be.svg',
    rank: 4,
    marketDigitalRevenuePrecent: 0,
    marketPhysicalRevenue: 0,
    marketDigitalRevenue: 0,
  },
  Norway: {
    marketNameEn: 'no',
    consolePlayer: '2.08M',
    pcRevenue: '89.5M',
    marketName: 'Norway',
    pcPlayer: '2.22M',
    marketPhysicalRevenuePrecent: 0,
    marketFlag: 'https://ogdb-cdn.intlgame.cn/front/static/img/flag0321/no.svg',
    rank: 23,
    marketDigitalRevenuePrecent: 0,
    marketPhysicalRevenue: 0,
    consoleRevenue: '284M',
    marketDigitalRevenue: 0,
  },
  Finland: {
    marketNameEn: 'fi',
    pcPlayer: '1.8M',
    consolePlayer: '1.5M',
    pcRevenue: '0.1B',
    consoleRevenue: '0.2B',
    marketName: 'Finland',
    marketPhysicalRevenuePrecent: 0,
    marketFlag: 'https://ogdb-cdn.intlgame.cn/front/static/img/flag0321/fi.svg',
    rank: 11,
    marketDigitalRevenuePrecent: 0,
    marketPhysicalRevenue: 0,
    marketDigitalRevenue: 0,
  },
  Denmark: {
    marketNameEn: 'dk',
    consolePlayer: '2.19M',
    pcRevenue: '85.7M',
    marketName: 'Denmark',
    pcPlayer: '2.34M',
    marketPhysicalRevenuePrecent: 0,
    marketFlag: 'https://ogdb-cdn.intlgame.cn/front/static/img/flag0321/dk.svg',
    rank: 10,
    marketDigitalRevenuePrecent: 0,
    marketPhysicalRevenue: 0,
    consoleRevenue: '272M',
    marketDigitalRevenue: 0,
  },
  Italy: {
    marketNameEn: 'it',
    pcPlayer: '18.3M',
    consolePlayer: '17.8M',
    pcRevenue: '0.5B',
    consoleRevenue: '1.8B',
    marketName: 'Italy',
    marketPhysicalRevenuePrecent: 0,
    marketFlag: 'https://ogdb-cdn.intlgame.cn/front/static/img/flag0321/it.svg',
    rank: 18,
    marketDigitalRevenuePrecent: 0,
    marketPhysicalRevenue: 0,
    marketDigitalRevenue: 0,
  },
  Mexico: {
    marketNameEn: 'mx',
    pcPlayer: '20.0M',
    consolePlayer: '20.3M',
    pcRevenue: '0.7B',
    consoleRevenue: '0.7B',
    marketName: 'Mexico',
    marketPhysicalRevenuePrecent: 0,
    marketFlag: 'https://ogdb-cdn.intlgame.cn/front/static/img/flag0321/mx.svg',
    rank: 20,
    marketDigitalRevenuePrecent: 0,
    marketPhysicalRevenue: 0,
    marketDigitalRevenue: 0,
  },
  'South Africa': {
    /*playper用的是22年数据， revenue用的是21年数据*/
    marketNameEn: 'za',
    pcPlayer: '2.8M',
    consolePlayer: '1.4M',
    pcRevenue: '15M',
    consoleRevenue: '11.2M',
    marketName: 'South Africa',
    marketPhysicalRevenuePrecent: 0,
    marketFlag: 'https://ogdb-cdn.intlgame.cn/front/static/img/flag0321/za.svg',
    rank: 28,
    marketDigitalRevenuePrecent: 0,
    marketPhysicalRevenue: 0,
    marketDigitalRevenue: 0,
  },
  Israel: {
    marketNameEn: 'il',
    consolePlayer: '1.52M',
    pcRevenue: '111M',
    marketName: 'Israel',
    pcPlayer: '1.75M',
    marketPhysicalRevenuePrecent: 0,
    marketFlag: 'https://ogdb-cdn.intlgame.cn/front/static/img/flag0321/il.svg',
    rank: 17,
    marketDigitalRevenuePrecent: 0,
    marketPhysicalRevenue: 0,
    consoleRevenue: '90.2M',
    marketDigitalRevenue: 0,
  },
  Australia: {
    marketNameEn: 'au',
    pcPlayer: '6.4M',
    consolePlayer: '7.4M',
    pcRevenue: '0.4B',
    consoleRevenue: '0.8B',
    marketName: 'Australia',
    marketPhysicalRevenuePrecent: 0,
    marketFlag: 'https://ogdb-cdn.intlgame.cn/front/static/img/flag0321/au.svg',
    rank: 2,
    marketDigitalRevenuePrecent: 0,
    marketPhysicalRevenue: 0,
    marketDigitalRevenue: 0,
  },
  Germany: {
    marketNameEn: 'de',
    pcPlayer: '28.3M',
    consolePlayer: '23.8M',
    pcRevenue: '1.6B',
    consoleRevenue: '3.4B',
    marketName: 'Germany',
    marketPhysicalRevenuePrecent: 0,
    marketFlag: 'https://ogdb-cdn.intlgame.cn/front/static/img/flag0321/de.svg',
    rank: 13,
    marketDigitalRevenuePrecent: 0,
    marketPhysicalRevenue: 0,
    marketDigitalRevenue: 0,
  },
  Indonesia: {
    marketNameEn: 'id',
    pcPlayer: '11.0M',
    consolePlayer: '4.3M',
    pcRevenue: '0.2B',
    consoleRevenue: '0.1B',
    marketName: 'Indonesia',
    marketPhysicalRevenuePrecent: 0,
    marketFlag: 'https://ogdb-cdn.intlgame.cn/front/static/img/flag0321/id.svg',
    rank: 15,
    marketDigitalRevenuePrecent: 0,
    marketPhysicalRevenue: 0,
    marketDigitalRevenue: 0,
  },
};

export const getPCConsoleMarkets = () => {
  let pcConsoleMarkets = [];
  for (let i in pcConsoleFixData) {
    pcConsoleMarkets.push(pcConsoleFixData[i].marketNameEn);
  }
  return pcConsoleMarkets
}